import b from 'b_';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import ConsoleStore from '../../../stores/ConsoleStore';
import ValueStore from '../../../stores/helpers/ValueStore';
import { REGISTRATION_TYPE } from '../../../stores/Policy/BrowsingRoles/BrowserIsolationOptionsStore';
import {
    REGISTRATION_TYPE as URL_REGISTRATION_TYPE
} from '../../../stores/Policy/BrowsingRoles/UrlIsolationOptionsStore';
import { Field } from '../../Fuse';
import FuseRadioButton from '../../FuseControls/FuseRadioButton';

export const RegistrationTypeLabels = {
    [REGISTRATION_TYPE.SAML_SSO]: <Fragment>SAML/SSO</Fragment>,
    [REGISTRATION_TYPE.ACTIVATION_CODES]: <Fragment>Activation Codes</Fragment>,
    [REGISTRATION_TYPE.ACTIVATION_LINKS]: <Fragment>Activation Links</Fragment>,
    [URL_REGISTRATION_TYPE.Automatic]: <Fragment>Automatic</Fragment>,
};

class RegistrationTypeField extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
        store: ValueStore.PropTypes,
        info: PropTypes.string,
        readOnly: PropTypes.bool,
    };

    labels = {
        [REGISTRATION_TYPE.SAML_SSO]: <Fragment>
            <b>SAML/SSO</b> - Users will be routed to the configured IdP for authentication
        </Fragment>,
        [REGISTRATION_TYPE.ACTIVATION_CODES]: <Fragment>
            <b>Activation Codes</b> - Users will be emailed a one-time activation code to register their browser
        </Fragment>,
        [REGISTRATION_TYPE.ACTIVATION_LINKS]: <Fragment>
            <b>Activation Links</b> - Users will be emailed a one-time activation link to register their browser
        </Fragment>,
    }

    render() {
        const { readOnly, store, console, info } = this.props;
        return <Field label="Registration Type" tooltip={info}>
            {readOnly ? RegistrationTypeLabels[store.getValue()] : Object.values(REGISTRATION_TYPE)
                .map((option) => <FuseRadioButton
                    key={option}
                    value={option}
                    store={store}
                    label={this.labels[option]}
                    qa={`registration-type-${option}`}
                    disabled={option === REGISTRATION_TYPE.SAML_SSO && !console.isSSOEnabled}
                />)}
        </Field>;
    }
}

export default inject('console')(observer(RegistrationTypeField));
